// @flow
export const USER_MODULE_NAME: 'user' = 'user';

export const USER_ACTION_TYPE: {
    CHECK_ALL_USERS: 'CHECK_ALL_USERS',
    GET_USER_DATA: 'GET_USER_DATA',
    GET_USER_LIST: 'GET_USER_LIST',
    SET_USER_TOTAL: 'SET_USER_TOTAL',
    TOGGLE_CHECKED_USER: 'TOGGLE_CHECKED_USER',
    UNCHECK_ALL_USERS: 'UNCHECK_ALL_USERS',
} = {
    CHECK_ALL_USERS: 'CHECK_ALL_USERS',
    GET_USER_DATA: 'GET_USER_DATA',
    GET_USER_LIST: 'GET_USER_LIST',
    SET_USER_TOTAL: 'SET_USER_TOTAL',
    TOGGLE_CHECKED_USER: 'TOGGLE_CHECKED_USER',
    UNCHECK_ALL_USERS: 'UNCHECK_ALL_USERS',
};

export const USER_STATUS = {
    ACTIVE: 2,
    DELETED: 3,
    INVITED: 1,
};

export const USER_STATUS_EDUCATION = {
    COMPLETED: 3,
    NOT_STARTED: 4,
    STUDYING: 2,
    SUSPEND: 5,
    WAITING: 1,
};

export const USER_ROLE_DATA: {
    ADMIN: 3,
    STUDENT: 4,
} = {
    ADMIN: 3,
    STUDENT: 4,
};

export const USER_LEARNING_ACTION: {
    COMPLETE: 'complete',
    RE_INVITE: 're-invite',
    RESTART: 'restart',
    START: 'start',
    STOP: 'stop',
} = {
    COMPLETE: 'complete',
    RE_INVITE: 're-invite',
    RESTART: 'restart',
    START: 'start',
    STOP: 'stop',
};

export const LIMIT_USERS: number = 10;

export const USER_SORT_TYPE: {
    ASC: 1,
    DEFAULT_SORT: 3,
    DESC: 2,
} = {
    ASC: 1,
    DEFAULT_SORT: 3,
    DESC: 2,
};
